module.exports = __webpack_public_path__ + "acabf2cc8aae17e35108de780b39938e.jpg";